"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSelector = void 0;

var _styles = require("./styles");

var _index = require("../../atoms/ProductImage/index");

var _jsxRuntime = require("react/jsx-runtime");

var ImageSelector = function ImageSelector(_ref) {
  var _images$values;

  var _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      setActiveImage = _ref.setActiveImage,
      modalSelector = _ref.modalSelector;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    className: modalSelector && "modal-image-selector",
    children: images === null || images === void 0 ? void 0 : (_images$values = images.values) === null || _images$values === void 0 ? void 0 : _images$values.map(function (image, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ProductImage, {
        img: image.src,
        altText: image.altText,
        imageType: modalSelector ? "catalogue-modal-image" : "carousel-image",
        onClick: function onClick() {
          return setActiveImage(index);
        }
      }, index);
    })
  });
};

exports.ImageSelector = ImageSelector;